import axios from "axios";
import { API_BASE_URL } from "../config/env";

const api = axios.create({
  baseURL: `${API_BASE_URL}`,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
  },
  withCredentials: true,
});

// 401 응답 시 로그인 페이지로 자동 이동 (세션 만료 처리)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // check-auth 요청은 제외 (ProtectedRoute에서 자체 처리)
      const isCheckAuth = error.config?.url?.includes('/api/check-auth');
      if (!isCheckAuth && !window.location.pathname.includes('/login')) {
        window.location.href = '/login?expired=true';
      }
    }
    return Promise.reject(error);
  }
);

export { api };
